import { render } from "./CreateSurveyPage.vue?vue&type=template&id=21b5741a&ts=true"
import script from "./CreateSurveyPage.vue?vue&type=script&lang=ts"
export * from "./CreateSurveyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Surveys/CreateSurveyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21b5741a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21b5741a', __exports__)) {
    api.reload('21b5741a', __exports__)
  }
  
  module.hot.accept("./CreateSurveyPage.vue?vue&type=template&id=21b5741a&ts=true", () => {
    api.rerender('21b5741a', render)
  })

}


export default __exports__